<template>
  <div class="block w-full relative">
    <input :id="inputId"
           :name="name"
           :type="type"
           :disabled="disabled"
           :readonly="readOnly"
           :autocomplete="autocomplete"
           :placeholder="placeholder"
           :maxlength="maxLength"
           v-model="model"
           @blur="onBlur"
           class="bg-gray-100 border border-gray-100 text-sm rounded-md focus:outline-none focus:ring-gray-600 focus:border-gray-600 block w-full py-3 px-2.5" />
  </div>
</template>

<script>
  import FieldBase from './../field-base'
  
  export default {
    name: 'IntInputField',
    
    mixins: [FieldBase],
    
    props: {
      type: {
        type: String, default: 'text', validator(val) {
          return ['text', 'number', 'password', 'date', 'email', 'search'].includes(val)
        }
      },
      maxLength: { type: Number }
    }
  }
</script>